/** Code de la catégorie Guerres d'Arran (anglais, tel que renvoyé par l'API) */
export const ARRAN_WAR_CATEGORY_CODE = 'arran-wars';
/** Code pour le filtre "Guerres d'Arran (crossover)" : catégorie + crossovers */
export const ARRAN_WAR_CROSSOVER_CATEGORY_CODE = 'arran-wars-crossover';

export const CATEGORY_CODE_TRANSLATIONS = {
    // Code anglais -> Code français pour l'URL
    'elves': 'elfes',
    'arran-wars': 'guerres-arran',
    'arran-wars-crossover': 'guerres-arran-crossover',
    'mages': 'mages',
    'dwarves': 'nains',
    'orcs-and-goblins': 'orcs-et-gobelins',
    'ogon-lands': 'terres-ogon',
    'ynuma-lands': 'terres-ynuma'
};

export const FRENCH_TO_ENGLISH_CATEGORY_CODES = Object.fromEntries(
    Object.entries(CATEGORY_CODE_TRANSLATIONS).map(([english, french]) => [french, english])
);

export const translateCategoryCodeToFrench = (englishCode) => {
    return CATEGORY_CODE_TRANSLATIONS[englishCode] || englishCode;
};

export const translateCategoryCodeToEnglish = (frenchCode) => {
    return FRENCH_TO_ENGLISH_CATEGORY_CODES[frenchCode] || frenchCode;
};
